import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { Button } from "react-bootstrap";

export default function PdfFullscreen({ pdf, nome, fullscreen, setFullscreen }) {
  
  // Função para disparar o download
  const downloadArquivo = () => {
    const link = document.createElement('a');
    link.href = pdf; // A URL do Blob que você já está usando no iframe
    link.download = nome || "arquivo";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const view = (
    <AnimatePresence>
      {fullscreen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.95)', zIndex: 99999,
            display: 'flex', flexDirection: 'column', padding: '20px'
          }}
        >
          {/* Header com Nome e Botões */}
          <div style={{ 
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: '15px', color: '#fff' 
          }}>
            <h5 style={{ margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '60%' }}>
              {nome}
            </h5>
            
            <div style={{ display: 'flex', gap: '10px' }}>
              {/* NOVO: Botão de Download */}
              <Button variant="outline-light" onClick={downloadArquivo}>
                <i className="bi bi-download"></i> Download
              </Button>

              <Button variant="light" onClick={() => setFullscreen(false)}>
                <i className="bi bi-x-lg"></i> Fechar
              </Button>
            </div>
          </div>

          {/* Área do Conteúdo */}
          <div style={{ flexGrow: 1, backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' }}>
            {pdf ? (
              <iframe
                src={pdf}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Visualizador"
              />
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                Carregando arquivo...
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return typeof document !== "undefined" ? createPortal(view, document.body) : null;
}